import { render, staticRenderFns } from "./PresupuestoFacturacion.vue?vue&type=template&id=fe4e0af2&"
import script from "./PresupuestoFacturacion.vue?vue&type=script&lang=js&"
export * from "./PresupuestoFacturacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports